import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Spinner from "components/Partials/Spinner";
import { GlobalStateProvider } from "context/GlobalStateProvider";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <GlobalStateProvider>
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>
    </GlobalStateProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
